import { Helmet } from "react-helmet-async";

/*
 * Emits a single <script type="application/ld+json"> into <head> via helmet.
 * The same JSON-LD is also baked into the static prerendered HTML by
 * scripts/inject-route-meta.js for non-JS crawlers and AI answer engines;
 * this client-side copy keeps structured data correct across SPA navigation
 * and for Google's JS-rendering pass.
 */
export default function JsonLd({ data }) {
  if (!data) return null;
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
